// This system keeps track of what levels are unlocked.
// Whether we unlock another group of levels.
// The game has 6 blocks of levels.
// We unlock each level based on whether or not every prior
// level has been completed.

import worldMapData from "../../../static/assets/worldMap.json";
import { PlayerState } from "../state/playerStateJson";

export const levelChunkSequence = [
  "chunk1",
  "chunk2",
  "chunk3",
  "chunk4",
  "chunk5",
  "chunk6",
];

export class LevelUnlockingSystem {
  public currentUnlockedBlock: number;
  constructor() {
    this.currentUnlockedBlock = 1;
    this.unlockLogic(() => {});
  }

  unlockLogic(cb: () => void): boolean {
    const lastUnlockLogic = this.currentUnlockedBlock || 1;
    this.currentUnlockedBlock = 1;
    for (const chunk of levelChunkSequence) {
      if (
        (worldMapData as any)[
          chunk
        ].every(({ levelKey }: { levelKey: string }) =>
          PlayerState.levelsCompleted?.has(levelKey)
        )
      ) {
        this.currentUnlockedBlock += 1;
      } else {
        break;
      }
    }

    if (this.currentUnlockedBlock > lastUnlockLogic) {
      cb();
      return true;
    }
    return false;
  }

  isLevelUnlocked(levelKeyString: string): boolean {
    let index = 0;
    for (const [chunk, array] of Object.entries(worldMapData)) {
      if (index >= this.currentUnlockedBlock) {
        return false;
      }
      if (array.some(({ levelKey }) => levelKey === levelKeyString)) {
        return true;
      }
      index++;
    }
    return false;
  }

  isChunkCompleted(currentChunk: number) {
    return currentChunk < this.currentUnlockedBlock - 1;
  }
}

const levelUnlockingSystem = new LevelUnlockingSystem();
export default levelUnlockingSystem;
